import { useEffect, useState } from "react";

const BlogPostingByLexical = () => {
      const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetch("https://ds3s15234f.execute-api.ap-south-1.amazonaws.com/dev/api/all-posts")
      .then(res => res.json())
      .then(data => setPosts(data.posts || []))
      .catch(err => console.error(err));
  }, []);

  return (
    <div>
      {posts.map((post, idx) => (
        <div key={idx}>
          <h3>{post.key}</h3>
          <div dangerouslySetInnerHTML={{ __html: post.html }} />
        </div>
      ))}
    </div>
  )
}

export default BlogPostingByLexical


